import { useCallback } from 'react';
import { useWorkFlowCanvas } from '../../../../contexts/CampaignFlowProvider';
import { useRemoveDisplayWebContent } from '../state/actions/useRemoveDisplayWebContent';
import { useDisableSplitTest } from '../../../../state/SplitTests/actions/useDisableSplitTest';
import { Canvas } from 'sections/onsite-campaigns/pages/CampaignEditor/domain/Canvas/Canvas';
import useOpenDrawerSettings from './useOpenDrawerSettings';
import { useGetVariantsSelector } from '../../../../state/SplitTests/selectors/useGetVariantsSelector';

export const useConvertSplitTestToMessage = () => {
  const { state, dispatch } = useWorkFlowCanvas();
  const { openDrawerSettings } = useOpenDrawerSettings();

  const removeDisplayWebsiteContent = useRemoveDisplayWebContent();
  const disableSplitTest = useDisableSplitTest();

  const getVariants = useGetVariantsSelector();

  return useCallback(
    ({ splitTestId, messageToKeepId }: { splitTestId: string; messageToKeepId: string }) => {
      const { nodes, edges } = Canvas.createFromState(state)
        .disableSplitTest(splitTestId, messageToKeepId)
        .convertToState();

      dispatch({
        type: 'UPDATE',
        payload: { nodes, edges },
      });

      getVariants(splitTestId)
        .filter(s => s.messageId !== messageToKeepId)
        .map(s => s.messageId)
        .forEach(s => {
          removeDisplayWebsiteContent(s);
        });

      disableSplitTest({ id: splitTestId });

      openDrawerSettings(messageToKeepId, 'display-website-content');
    },
    [disableSplitTest, dispatch, getVariants, openDrawerSettings, removeDisplayWebsiteContent, state],
  );
};
